import { DesignView } from '../views';
export default DesignView;
